// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bundle-discount-label[data-v-24cf3e3a]{float:right}", ""]);
// Exports
module.exports = exports;
